import {
  AddressDetailsReadonly,
  AutoFillVerificationForm,
  PreviousAddressDetailsValues,
} from '@/types/v2/address'

export const getDefaultValues = (previousValues?: PreviousAddressDetailsValues): AutoFillVerificationForm => ({
  city: previousValues?.city || '',
  stateId: previousValues?.stateId || 1,
  street: previousValues?.street || '',
  zipCode: previousValues?.zipCode || '',
  extraInfo: previousValues?.extraInfo || '',
  county: previousValues?.county || '',
  is_verified: false,
})

export const getAddressDetailsWithPreviousValues = (
  previousValues: PreviousAddressDetailsValues,
  states: any[]
): AddressDetailsReadonly => {
  const found = states.find((state) => state.id === Number(previousValues?.stateId))
  return {
    streetAddress: previousValues.street || '',
    extraInfo: previousValues.extraInfo || '',
    city: previousValues?.city || '',
    county: previousValues?.county || '',
    state: found || {},
    zipCode: previousValues?.zipCode || '',
  }
}

export const capitalize = (sentence: string): string =>
  sentence.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
